import { ReactNode } from 'react';
import { MdError } from 'react-icons/md';
import { Tooltip } from '@ds';
import { getIsAutogenerated } from '@lp/features/Scheduler/utils';
import { PlanningProcess } from '@/api/apis/resources/schedule';

type AutogenerationInfoProps = {
  planningData: PlanningProcess;
};

export const AutogenerateInfo = ({ planningData }: AutogenerationInfoProps) => {
  const { autoSchedulerInfo, lastErrors, hrSystemError } = planningData;
  const isGenerationError = lastErrors && lastErrors.length > 0;
  const isAutoSchedulerError = !!autoSchedulerInfo && !getIsAutogenerated(planningData.autoSchedulerInfo);
  const isWorkdayError = !!hrSystemError;

  if (!isGenerationError && !isAutoSchedulerError && !hrSystemError) return null;

  const getTitle = () => {
    switch (true) {
      case isGenerationError:
        return <span className="text-m-sb">Generation Error</span>;
      case isAutoSchedulerError:
        return (
          <span className="text-m-r">
            Generation Status: <b>{autoSchedulerInfo?.resultType}</b>
          </span>
        );
      case isWorkdayError:
        return <span className="text-m-sb">Workday Error</span>;
      default:
        return null;
    }
  };

  const getTooltipContent = (): ReactNode => {
    switch (true) {
      case isGenerationError:
        return lastErrors.length === 1 ? (
          lastErrors[0].message
        ) : (
          <ul className="list-disc list-outside ms-3">
            {lastErrors.map((err) => (
              <li key={err.message}>{err.message}</li>
            ))}
          </ul>
        );
      case isAutoSchedulerError:
        return autoSchedulerInfo?.errorMessage;
      case isWorkdayError:
        return hrSystemError.message;
      default:
        return null;
    }
  };

  return (
    <Tooltip placement="bottom-end" content={getTooltipContent()}>
      <div className="flex items-center justify-end text-end gap-2 text-danger-30">
        {getTitle()}
        <MdError size={20} />
      </div>
    </Tooltip>
  );
};
